/**
 * Suspense fallback for lazy-loaded app bundles (T062 / FR-032).
 *
 * Renders while a code-split app chunk (SurfTime, LocalTea, BitzBuggy,
 * LLM Chat, Smart News, and their admin panels) downloads. Uses only the
 * theme tokens defined at `:root` in shared/platform/theme/tokens.css, so
 * it reads correctly whether it appears inside the neutral platform shell
 * or inside an app-specific theme scope (`.theme-{app}[data-mode]`) — no
 * app-specific styling to keep it truly shared across every lazy boundary.
 */
export function RouteFallback() {
  return (
    <div
      className="flex min-h-[50vh] w-full items-center justify-center"
      role="status"
      aria-live="polite"
    >
      <div
        className="h-8 w-8 rounded-full border-2 motion-safe:animate-spin"
        style={{ borderColor: 'var(--border)', borderTopColor: 'var(--accent)' }}
        aria-hidden="true"
      />
      <span className="sr-only">Loading…</span>
    </div>
  );
}
